import { render } from "./PriceGroupAssignmentModal.vue?vue&type=template&id=7058db79&scoped=true&ts=true"
import script from "./PriceGroupAssignmentModal.vue?vue&type=script&lang=ts"
export * from "./PriceGroupAssignmentModal.vue?vue&type=script&lang=ts"

import "./PriceGroupAssignmentModal.vue?vue&type=style&index=0&id=7058db79&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7058db79"]])

export default __exports__